import React from 'react';
import MessageBox from './MessageBox';

const WarningBox = ({children, list}) => {       
    return (        
        <div>
            {list.map((item, index) =>                 
                <MessageBox key={index} messageHeader={item} messageBody={""} messageType="alert"/>
            )}            
            {children}
        </div>
      );
};

export default WarningBox;
